declare const CONFIG: {
  API_URL: string;
};

export const { API_URL } = CONFIG;
